import { MarkExtension } from '../../../core/index.js';
import 'prosemirror-model';
import { InputRule } from 'prosemirror-inputrules';
import { PluginKey } from 'prosemirror-state';
import { toggleMark } from 'prosemirror-commands';

/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 粗体
var regexpBold = /(?:\*\*)([^]+)(?:\*\*)\s$/;
// eslint-disable-next-line no-useless-escape
var regexpBoldFullwidth = /(?:\＊\＊)([^]+)(?:\＊\＊)\s$/;

var convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var isOfType = function(type) {
    return function(value) {
        return (typeof value === "undefined" ? "undefined" : _typeof(value)) === type;
    };
};
var isFunction = isOfType("function");

var findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return findParentNodeClosestToPos($from, predicate);
    };
};
var isInNodeType = function(nodeType) {
    return function(selection) {
        var predicate = function(node) {
            return node.type === nodeType;
        };
        return !!findParentNode(predicate)(selection);
    };
};
// 在这里主动触发ProseMirror重绘机制 https://km.sankuai.com/page/759472057
var enhancedToggleMark = function(markType) {
    var isHackFocus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, attrs = arguments.length > 2 ? arguments[2] : void 0;
    var originCmd = toggleMark(markType, attrs);
    return function(_, __, view) {
        var res = originCmd(_, __);
        if (isHackFocus) {
            view.focus();
            view.dom.blur();
        }
        return res;
    };
};

/**
 * 通用配置
 */ var pluginKey = new PluginKey("image");

var isMarkActive = function(type) {
    return function(state) {
        var selection = state.selection, doc = state.doc, storedMarks = state.storedMarks;
        var $from = selection.$from, empty = selection.empty;
        if (empty) {
            return !!type.isInSet(storedMarks !== null && storedMarks !== void 0 ? storedMarks : $from.marks());
        }
        return doc.rangeHasMark(selection.from, selection.to, type);
    };
};
var markInputRule = function(param) {
    var regexp = param.regexp, type = param.type, getAttrs = param.getAttrs;
    return new InputRule(regexp, function(state, match, start, end) {
        // TODO:只对选中区域设置mark，没有将整个node节点设置
        var tr = state.tr;
        // @ts-ignore
        var attrs = isFunction(getAttrs) ? getAttrs(match) : getAttrs;
        var markEnd = end;
        if (match[1]) {
            var startSpaces = match[0].search(/\S/);
            var textStart = start + match[0].indexOf(match[1]);
            var textEnd = textStart + match[1].length;
            if (textEnd < end) {
                tr.delete(textEnd, end);
            }
            if (textStart > start) {
                tr.delete(start + startSpaces, textStart);
            }
            markEnd = start + startSpaces + match[1].length;
        }
        return tr.addMark(start, markEnd, type.create(attrs)).removeStoredMark(type);
    });
};

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var StrongExtension = /*#__PURE__*/ function(MarkExtension) {
    _inherits(StrongExtension, MarkExtension);
    var _super = _createSuper(StrongExtension);
    function StrongExtension() {
        _classCallCheck(this, StrongExtension);
        return _super.apply(this, arguments);
    }
    var _proto = StrongExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            toggleStrong: function() {
                return enhancedToggleMark(type);
            },
            isStrongActive: function() {
                return isMarkActive(type);
            },
            isStrongDisabled: function() {
                return function(param) {
                    var selection = param.selection, schema = param.schema;
                    return isInNodeType(schema.nodes.code_block)(selection) || isInNodeType(schema.nodes.heading)(selection);
                };
            }
        };
    };
    _proto.keys = function keys(param) {
        var type = param.type;
        return {
            "Mod-b": convertCommand(enhancedToggleMark(type, false))
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type;
        return [
            markInputRule({
                regexp: regexpBold,
                type: type
            }),
            markInputRule({
                regexp: regexpBoldFullwidth,
                type: type
            })
        ];
    };
    _createClass(StrongExtension, [
        {
            key: "name",
            get: function get() {
                return "strong";
            }
        }
    ]);
    return StrongExtension;
}(MarkExtension);

export { StrongExtension };
//# sourceMappingURL=index.js.map
